import { Injectable, Optional, SkipSelf } from '@angular/core';
import {
  CanActivate, CanActivateChild, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanLoad
} from '@angular/router';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

  constructor(private router: Router, @Optional() private auth: AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const redirect_to: string = state.url;
    const isSignup = state.url.includes("signup")
    const user = await this.auth.authenticated();
    if (user && (user.id || user._id)) {
      return true;
    }
    this.router.navigate([isSignup ? '/signup' : '/login'], redirect_to.includes('dashboard') ? {} : { queryParams: { redirect_to } })
    return false

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(route, state)
  }

  async canLoad(): Promise<boolean> {
    const user = await this.auth.authenticated()
    if (user && (user.id || user._id)) {
      return true;
    }
    return false
  }

}
